import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiCallsComponent } from './api-calls.component';
import { MaterialModuleMobi } from '../material/material.module';
import { SharedModule } from '../shared.module';
import { AppPermissionsPipe } from '../shared_pipes/appPermissions.pipe';



@NgModule({
  declarations: [ApiCallsComponent],
  imports: [
    CommonModule,
    MaterialModuleMobi,
    SharedModule,
    AppPermissionsPipe
  ],
  exports:[ApiCallsComponent]
})
export class ApiCallsModule { }
